export default {
   	getHonourExplain: '/honour/client/honourDesc'
}
